<template lang="html">
    <section v-if="user.profile">
        <div>
            <div class="notification is-primary">
                <h1 class="title">Mi Perfil</h1>
            </div>

            <div class="columns">
                <div class="column is-3">
                    <b-field class="file">

                        <a>
                            <figure class="image is-circle">
                                <div class="overlay">

                                </div>
                                <img src="/img/user.png">
                            </figure>
                        </a>

                    </b-field>
                </div>
                <div class="column">
                    <div class="columns">
                        <div class="column">
                            <form-input name="name" v-model="$auth.user().profile.name" :error="errors.name"
                                        holder="Pepe" label="Nombre" type="text"></form-input>
                            <form-input name="last_name" v-model="$auth.user().profile.last_name"
                                        :error="errors.last_name" holder="Perez" label="Apellido Paterno"
                                        type="text"></form-input>
                            <form-input name="other_name" v-model="$auth.user().profile.other_name"
                                        :error="errors.other_name" holder="Lopez" label="Apellido Materno"
                                        type="text"></form-input>
                            <form-input name="email" v-model="$auth.user().email" :error="errors.email"
                                        holder="pepe@empresa.com.mx" label="Correo electrónico"
                                        type="email"></form-input>
                            <b-field label="Fecha de nacimiento">
                                <b-datepicker placeholder="Clic para seleccionar" v-model="birthday" @input="setDate"
                                              icon="calendar-alt"></b-datepicker>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-radio v-model="$auth.user().profile.gender"
                                     native-value="male">
                                Masculino
                            </b-radio>
                            <b-radio v-model="$auth.user().profile.gender"
                                     native-value="feme">
                                Femenino
                            </b-radio>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div v-if="$auth.check(['ivr_worker'])">
                                    <form-input name="extension" v-model="extension" :error="errors.extension" holder="Num. Extensión"
                                                readonly="true"
                                                label="Extensión" type="text" />
                            </div>
                        </div>
                        <div class="column">
                            <div v-if="$auth.check(['ivr_worker'])">
                                <form-input name="personal_phone" v-model="personal_phone" :error="errors.personal_phone" holder="Num. Extensión"
                                            label="Teléfono personal" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <form-input name="password" :error="errors.password" v-model="$auth.user().password"
                                        holder="●●●●●●●" label="Contraseña" type="password" reveal></form-input>
                        </div>
                        <div class="column">
                            <form-input name="password_confirmation" :error="errors.password_confirmation"
                                        v-model="$auth.user().password_confirmation" holder="●●●●●●●"
                                        label="Confirmación" type="password" reveal></form-input>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="block">
                                <div class="field is-grouped">
                                    <p class="control">
                                        <button class="button is-success" @click="update">Actualizar</button>
                                    </p>
                                    <p class="control">
                                        <button class="button" type="reset" @click="cancel">Cancelar</button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                loading: false,
                errors: {},
                user: {},
                ready: false,
                birthday: new Date(),
                password: '',
                password_confirmation: '',
                extension: this.$auth.user().worker?this.$auth.user().worker.extension:'',
                personal_phone: this.$auth.user().worker?this.$auth.user().worker.personal_phone:''
            }
        },
        mounted() {
            this.prepareComponent();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => vm.prepareComponent())
        },
        props: {
            uuid: String,
        },
        methods: {
            prepareComponent() {
                this.user = {
                    profile: {
                        name: this.$auth.user().profile.name,
                        last_name: this.$auth.user().profile.last_name,
                        other_name: this.$auth.user().profile.other_name,
                        email: this.$auth.user().email,
                        gender: this.$auth.user().profile.gender,
                    },
                    uuid: this.$auth.user().uuid
                }
                this.birthday = new Date(this.$auth.user().profile.birthday);
            },
            update() {
                this.errors = {};

                var userData = [{
                    "name": this.$auth.user().profile.name,
                    "last_name": this.$auth.user().profile.last_name,
                    "other_name": this.$auth.user().profile.other_name,
                    "email": this.$auth.user().email,
                    "password": this.$auth.user().password,
                    "password_confirmation": this.$auth.user().password_confirmation,
                    "role": this.$auth.check(['ivr_worker'])? 'ivr_worker': this.$auth.user().role[0],
                    "birthday": this.birthday,
                    "gender": this.$auth.user().profile.gender,
                    'extension': this.extension,
                    'personal_phone': this.personal_phone
                }
                ];

                this.$dialog.confirm({
                    title: 'Actualizar datos',
                    message: '¿Esta seguro de <b>actualizar</b> su perfil?',
                    cancelText: 'Cancelar',
                    confirmText: 'actualizar',
                    type: 'is-success',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$loader.show();
                        this.$http.put('/user/' + this.$auth.user().uuid, userData[0]).then(({data}) => {


                            this.$notify.success(data);
                            this.$loader.hide();
                            // this.$router.push('/home');
                        }, ({response}) => {
                            this.$loader.hide();
                            let data = response.data || {};
                            this.errors = data.errors || {};
                            this.$notify.danger(data.message);
                        })
                    }
                })


            },
            cancel() {
                this.$emit('cancel');
                this.$router.push('/home');
            },

            setDate(val) {

                this.user.profile.birthday = moment(val).format();
            }

        }
    }
</script>

<style lang="css">
</style>
